import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Text from './Text';

const baseStyles = ({ theme }) => css`
  color: ${theme.colors.n900};
  display: flex;
  width: 100%;
  a {
    color: ${theme.colors.n900};
    text-decoration: underline;
  }
`;

const Container = styled('div')(baseStyles);

const textWrapperBaseStyles = ({ theme }) => css`
  margin: 0 ${theme.spacings.kilo};
  width: 100%;
  max-width: 1200px;
`;

const textWrapperAlignStyles = ({ theme, align }) =>
  align &&
  css`
    text-align: ${align};
    padding: 0 ${theme.spacings.mega};
  `;
const customStylesFooter = ({ theme, styles }) =>
  styles &&
  css`
    ${styles(theme)}
  `;

const TextWrapper = styled('div')(textWrapperBaseStyles, textWrapperAlignStyles, customStylesFooter);

const TextBlock = ({ text, size, align, styles, ...props }) => (
  <Container>
    <TextWrapper align={align} styles={styles}>
      <Text
        {...{
          as: 'p',
          size: size || 'byte',
          ...props,
        }}
      >
        {text}
      </Text>
    </TextWrapper>
  </Container>
);

TextBlock.propTypes = {
  text: PropTypes.string,
  size: PropTypes.string,
  align: PropTypes.string,
  noMargin: PropTypes.bool,
};

TextBlock.defaultProps = {
  text: 'This is a text block.',
  noMargin: false,
};

export default TextBlock;
